import axios from 'axios'
import { getToken } from '@/utils/auth'
import Store from '@/store'
import { Toast } from 'vant'

const http = axios.create({
  timeout: 15000,
  baseURL: '', // process.env.VUE_APP_BASE_API || '',
  headers: { // 设置默认请求头
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
    'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS',
    'Content-Type': 'application/json;charset=UTF-8',
  }
})

// 添加请求拦截器
http.interceptors.request.use(config => {
  // let url = config.url
  // get参数编码
  // if (config.method === 'get' && config.params) {
  //   url += '?'
  //   for (const key of Object.keys(config.params)) {
  //     let newVal = encodeURIComponent(config.params[key])
  //     if (newVal == 'undefined' || newVal == 'null' || newVal == undefined || newVal == null ) { newVal = '' }
  //     if(newVal) { url += `${key}=${newVal}&` }
  //   }
  //   url = url.substring(0, url.length - 1)
  //   config.params = {}
  // }
  // config.url = url
  config.headers['token'] = getToken()
  config.headers['apikey'] = 'xm-app-auth'
  config.headers['appCode'] = 'srm'
  return config
}, error => {
  return Promise.reject(error)
})

http.interceptors.response.use(res => {
  const {code, miniCode, msg} = res.data
  if (res.status === 200) {
    if ((code === '1001' || code == '403') && (miniCode === '004' || miniCode === '005')) {
      Store.dispatch('user/resetToken').then(() => { 
        // 跳转到登录页
        window.location.href = '/login'
      })
    } 

    if(code === '1002') { 
      Toast(msg || '')
    }

    if (code == 500 || code == '80') {
      Toast(msg || '服务升级中，请稍候再试')
      return Promise.reject(res)
    }    
    return res.data
  } 
}, err => {
  let { httpStatus,code } = err.response.data
  if (httpStatus >= 500) {
    Toast('服务升级中，请稍候再试')
  } else {
     if (code == '403') { 
      Store.dispatch('user/resetToken').then(() => { 
        // 跳转到登录页
        window.location.href = '/login'
      }) 
    } 
  }
  return Promise.reject(err)
})

export default {
  get(url, data = {}, options={}) {
    return http.get(url, {
      params: data,
      header: Object.assign(http.defaults.headers, options.header),
    })
  },
  post(url, data = {}, options={}) {
    return http.post(url, data, options)
  },
  uploadFile(url, data = {}, options={}) {
    return http.post(
      url, 
      data, 
      Object.assign({}, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }, options)
    )
  },
  put(url, data = {}) {
    return http.put(url, data)
  },
  delete(url, data = {}) {
    return http.delete(url, {
      params: data
    })
  }
}
